import { DateTime } from "luxon";
import { RoutineOccasionStatus } from "./__generated__/WidgetRoutineOverviewListItemExpireText_routineOccasion.graphql";

const occasionStatusPriority = (status: RoutineOccasionStatus): number => {
  //higher number means more important
  switch (status) {
    case "IN_PROGRESS_EXPIRED":
      return Priority.EXPIRED;
    case "IN_PROGRESS":
      return Priority.PENDING_EXPIRING;
    case "FUTURE":
      return Priority.FUTURE;
    case "COMPLETED":
      return Priority.DONE;
    case "REQUIRED_COMPLETED":
      return Priority.REQUIRED_DONE;

    case "NOT_COMPLETED":
      return -Infinity;
  }
  return 0;
};

function mapper(val: {
  expireAt: string;
  startAt: string;
  status: RoutineOccasionStatus;
}) {
  const priority = occasionStatusPriority(val.status);
  return {
    priority,
    date:
      priority === Priority.PENDING_EXPIRING || priority === Priority.EXPIRED
        ? DateTime.fromISO(val.expireAt).toMillis()
        : DateTime.fromISO(val.startAt).toMillis(),
  };
}

enum Priority { // SECONDARY SORT BASED ON:
  EXPIRED = 10, // OLDEST EXPIRE DATE
  PENDING_EXPIRING = 9, // OLDEST EXPIRE DATE
  PENDING_NON_EXPIRING = 8, // OLDEST START DATE, e.g. unscheduled todos
  FUTURE = 7, // OLDEST START DATE
  REQUIRED_DONE = 6,
  DONE = 5, // OLDEST START DATE
}

export function sortTeamDividedRoutineOccasion<
  T extends {
    inProgressOccasion: {
      expireAt: string;
      startAt: string;
      status: RoutineOccasionStatus;
    } | null;
  },
>(routines: readonly T[]): T[] {
  return routines
    .filter((a) => a?.inProgressOccasion)
    .sort((a, b) => {
      const compA = mapper(a.inProgressOccasion!);
      const compB = mapper(b.inProgressOccasion!);
      if (compA.priority !== compB.priority) {
        return compA.priority > compB.priority ? -1 : 1; // higher number gets higher up
      }
      return compA.date < compB.date ? -1 : 1; // lower number gets higher up
    });
}
